import React from 'react';
import CalculateIcon from '@mui/icons-material/Calculate';
import DeleteIcon from '@mui/icons-material/Delete';
import { Divider } from '@mui/material';

import { hasHangerUpgradeAndAnalyzeFeatureFlag, hasNewLayoutModeFeatureFlag } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { deleteHangers, selectHangers } from '../../../../store/actions/paragonProcessActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { ToggleLockingMenuItem } from '../shared-menu-items/ToggleLockingMenuItem';

export function HangerContainerMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();
  const activeComponentDesign = useAppSelector(getActiveComponentDesign);

  const allowLocking = useAppSelector(hasHangerUpgradeAndAnalyzeFeatureFlag);
  const isLayoutUser = useAppSelector(hasNewLayoutModeFeatureFlag);

  if (!isLayoutUser || !activeComponentDesign) return null;

  return (
    <SceneMenuContent>
      <SceneMenuItem
        icon={<CalculateIcon />}
        text="Select Hangers"
        onClick={async () => {
          await dispatch(selectHangers(activeComponentDesign));
          monitor.recordInteraction('Select Hangers menu item clicked');
        }}
      />

      {allowLocking && (
        <>
          <Divider />

          <ToggleLockingMenuItem type="hanger" context="container" />
        </>
      )}

      <Divider />

      <SceneMenuItem
        icon={<DeleteIcon />}
        text="Delete All Hangers"
        onClick={async () => {
          await dispatch(
            deleteHangers(
              activeComponentDesign,
              activeComponentDesign.component.hangers.map(({ guid }) => guid),
            ),
          );
          monitor.recordInteraction('Delete All Hangers menu item clicked');
        }}
      />
    </SceneMenuContent>
  );
}
